var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b-wrap"},[_c('b-dropdown',_vm._b({ref:"dropdown",attrs:{"position":_vm.computedPosition},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_vm._t("trigger")]},proxy:true}],null,true)},'b-dropdown',_vm.$props,false),[_vm._v(" "),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }